import {debounce} from 'throttle-debounce';
import includes from 'array-includes';
import Observer from 'common/scripts/observer';

const observer = new Observer();

class Header {
    init(options) {
        this.header = options.headerWrap;
        this.subMenu = options.subMenu;
        this.targetScroll = options.targetScroll;
        this.heightHeader = this.header.offsetHeight;
        this.scrollPosition = 0;
        this.sections = [];
        this.openFilter = false;

        this.initState();
        this._subscribes();
        this._bindEvents();
    }

    /**
     * Обрабатывает события.
     */
    _bindEvents() {
        window.addEventListener('scroll', debounce(10, () => {
            if (!this.openFilter) {
                this._changeState();
                this._changeStateAnchor();
            }
        }));

        window.addEventListener('resize', debounce(10, () => {
            if (this.openFilter) {
                this.header.classList.add('is-hidden');
            } else {
                this._changeState();
                this._changeStateAnchor();
            }
        }));
    }

    /**
     * Метод содержит в себе колбэки на события других модулей.
     * @private
     */
    _subscribes() {
        observer.subscribe('scrollbyStart', () => {
            this.scrollByStart = true;
        });

        observer.subscribe('scrollbyFinish', () => {
            this.scrollByStart = false;
        });

        // скрывает/показывает шапку взависимости влизает ли фильтр во всю высоту или нет
        observer.subscribe('parametricfilterOpen', (filter) => {
            this.isHidden = this.header.classList.contains('is-hidden');
            this.openFilter = true;
            this.header.classList.add('is-overlay');

            if (window.innerHeight < filter.scrollHeight + this.header.scrollHeight) {
                this.header.classList.add('is-hidden');
            }
        });

        observer.subscribe('parametricfilterClose', (filter) => {
            this.openFilter = false;
            this.header.classList.remove('is-overlay');

            if (window.innerHeight < filter.scrollHeight && !this.isHidden) {
                this.header.classList.remove('is-hidden');
            }
        });
    }

    /**
     * Ставит изначальное состояние
     * @private
     */
    initState() {
        this.scrollPosition = window.scrollY;

        if (!this.isScrollInTarget() && !this.header.classList.contains('header-new')) {
            this.header.classList.add('header_theme_blue');
        }
    }

    /**
     * Изменяет состояние хэдера
     * @private
     */
    _changeState() {
        this.scrollPosition = window.scrollY;
        this.targetScroll = this.header;

        if (this.isScrollUp() && !this.isScrollInTarget()) {
            this.header.classList.remove('is-scroll');
            this.header.classList.remove('is-hidden');

            if (this.header.classList.contains('header-new')) {
                this.header.classList.add('header_theme_light');

                if (this.header.classList.contains('special')) {
                    this.header.classList.remove('header_theme_special');
                }
            } else {
                this.header.classList.add('header_theme_blue');
            }
        }

        if (this.isScrollUp() && this.isScrollInTarget()) {
            this.header.classList.remove('is-transition');

            if (this.header.classList.contains('header-new')) {
                this.header.classList.remove('header_theme_light');

                if (this.header.classList.contains('special')) {
                    this.header.classList.add('header_theme_special');
                }
            } else {
                this.header.classList.remove('header_theme_blue');
            }
        }

        if (this.isScrollDown()) {
            this.header.classList.add('is-hidden');

            if (this.header.classList.contains('header-new')) {
                this.header.classList.add('header_theme_light');

                if (this.header.classList.contains('special')) {
                    this.header.classList.remove('header_theme_special');
                }
            } else {
                this.header.classList.add('header_theme_blue');
            }
        }

        if (this.isScrollDown() && !this.isScrollInTarget()) {
            this.header.classList.add('is-transition');
            this.header.classList.add('is-scroll');
        }

        if (this.heightHeader > this.scrollPosition) {
            this.header.classList.remove('is-hidden');
        }

        this.prevScrollPosition = this.scrollPosition;
    }

    /**
     * Проверяет скролл вверх
     * @returns {boolean} - true - скролл вверх
     */
    isScrollUp() {
        const stepScrollTop = -1;
        // если разница между текущим и предыдущим значением сколла меньше констаны

        return this.scrollPosition - this.prevScrollPosition < stepScrollTop;
    }

    /**
     * Проверяет скролл вниз
     * @returns {boolean} - true - скролл вниз
     */
    isScrollDown() {
        const stepScrollBottom = 1;

        // если скролл больше высоты хэдера, и разница между текущим и предыдущим значением скролла больше константы
        return this.scrollPosition > this.heightHeader &&
            (this.scrollPosition - this.prevScrollPosition) > stepScrollBottom;
    }

    /**
     * Проверяет является ли текущий сколл в рамках элемента-таргета
     * @returns {boolean} - true - скролл есть
     */
    isScrollInTarget() {
        if (!this.targetScroll) {
            return false;
        }

        const saveZone = 50;

        // Если текущий скролл больше суммы высоты хэдера и константы
        return this.targetScroll.offsetHeight - saveZone > this.scrollPosition;
    }


    /**
     * Меняет состояние якорей при скролле по странице.
     * @private
     */
    _changeStateAnchor() {
        const section = Array.from(document.querySelectorAll('.j-anchor-section'));

        section.forEach((item) => {
            // если блок в 1/3 экрана, то состояние изменится (меньше не делать, иначе будут проблемы с мелкими секциями)
            const safeZone = window.innerHeight / 3;
            const sectionTop = item.getBoundingClientRect().top + pageYOffset - safeZone;

            if (this.scrollPosition > sectionTop) {
                if (!includes(this.sections, item)) {
                    this.sections.push(item);
                }
            }

            if (this.scrollPosition < sectionTop) {
                if (includes(this.sections, item)) {
                    this.sections.splice(this.sections.length - 1, 1);
                }
            }

            const sectionId = this.sections.length ? `#${this.sections[this.sections.length - 1].id}` : false;

            if (!this.scrollByStart) {
                observer.publish('anchorChangeSection', sectionId);
            }
        });
    }
}

export default Header;
